import { getLocalePath } from '@src/components/seo/seo-page-router.helper'
import { NEXT_PUBLIC_SITE_URL } from '@src/config/env'
import { getProductLink } from '@src/quince-components/src/molecules/productCard/productCard.helpers'
import Product from '@src/quince-site-common/src/domains/Product'
import { ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant/BaseProductVariant'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

import { DYNAMIC_APP_LINK } from '../../../utils/constants'

function withLbUserId(url: string, lbUserId?: string): string {
  if (!lbUserId?.trim() || !URL.canParse(url)) return url
  const u = new URL(url)
  u.searchParams.set('web_lb_user_id', lbUserId.trim())
  return u.toString()
}

export function buildPageUrl({
  locale,
  product,
  selectedOptions,
  lbUserId,
}: {
  slug?: string
  locale: string
  product?: Product
  selectedOptions?: ProductVariantOption[]
  lbUserId?: string
}) {
  const baseUrl =
    !product && isBrowser()
      ? window.location.href
      : (() => {
          const productLink = product ? getProductLink(product, selectedOptions ?? []) : ''
          const path = productLink.startsWith('/') ? productLink.substring(1) : productLink
          return `${NEXT_PUBLIC_SITE_URL}/${getLocalePath(locale, path)}`
        })()
  return withLbUserId(baseUrl, lbUserId)
}

export function buildAppDeepLinkUrl(pageUrl: string): string {
  const encodedUrl = encodeURIComponent(pageUrl)
  const url = new URL(DYNAMIC_APP_LINK)

  url.searchParams.set('pid', 'website')
  url.searchParams.set('c', 'app_exclusive')
  url.searchParams.set('deep_link_value', encodedUrl)

  return url.toString()
}
